---
title: "Как удалить геолокацию из JPG перед отправкой"
description: "Проверяем GPS в EXIF, очищаем локальную копию JPG в браузере и повторно смотрим метаданные перед отправкой файла."
locale: "ru"
date: "2026-08-03"
tags: ["exif", "gps", "метаданные", "приватность"]
relatedTools: ["metadataViewer", "removeExif"]
translations:
  en: "how-to-remove-location-data-from-photo-before-sharing"
faq:
  - q: "Удаление EXIF меняет само изображение JPG?"
    a: "Да. Imgify декодирует JPG и создаёт новую копию с качеством 95%, поэтому размер файла и отдельные пиксели могут измениться."
  - q: "Можно ли проверить, что GPS исчез из готового JPG?"
    a: "Да. Скачайте очищенную копию и снова откройте её в просмотрщике метаданных. Раздел GPS должен быть пустым."
  - q: "Фото отправляется на сервер во время проверки и очистки?"
    a: "Нет. Оба инструмента читают и обрабатывают файл локально в браузере. Обычные запросы страницы и аналитики не содержат байты фотографии."
---

Фотография объявления снята у входа в дом. В кадре нет номера, зато внутри
JPG могут остаться GPS-координаты, время съёмки и модель телефона. Перед
отправкой исходного файла лучше проверить не миниатюру, а его метаданные.

Откройте [просмотрщик EXIF](/posmotret-exif) и выберите JPG. Он читает EXIF,
GPS, IPTC и XMP локально в браузере. Если в разделе GPS есть широта и долгота,
получатель исходного файла сможет извлечь их тем же способом. Карта на экране
не нужна: сами числа уже указывают точку съёмки.

## Как убрать GPS и получить отдельную копию

Перейдите в [удаление EXIF](/udalit-exif), загрузите тот же JPG и скачайте
очищенный результат. Исходник останется на месте. Imgify декодирует фотографию
и сохраняет новую JPEG-копию с качеством 95%. EXIF и XMP исходного файла в неё
не переносятся.

У этого способа есть цена: JPEG использует сжатие с потерями. После повторного
кодирования могут измениться размер файла и отдельные пиксели, а сохранение
исходного ICC-профиля не гарантируется. Для объявления или разовой отправки
это обычно приемлемо. Архивный оригинал лучше не заменять очищенной копией.

Файл ограничен 50 MB, 36 мегапикселями и 32768 пикселями по каждой стороне.
Если проверка контейнера или декодирование не проходит, imgify показывает
ошибку и не отправляет фото на сервер для запасной обработки.

## Проверка после очистки

Скачанную JPG-копию снова откройте в
[просмотрщике метаданных](/posmotret-exif). GPS, серийный номер камеры, автор и
другие распознанные поля, удалённые при пересохранении, не должны появиться в
результате. Это полезнее обещания «метаданные удалены»: проверяется именно тот
файл, который вы собираетесь отправить.

Не путайте метаданные с содержимым кадра. Удаление EXIF не скроет вывеску,
номер машины, отражение в окне или узнаваемый вид. Для таких деталей нужен
[инструмент размытия](/razmyt-foto), где область выбирается вручную.

PNG и WebP тоже можно очистить через `/udalit-exif`, но алгоритм там другой:
imgify переписывает контейнер и удаляет известные EXIF, XMP и текстовые блоки,
сохраняя пиксельные данные. Неизвестные и проприетарные блоки могут остаться,
поэтому инструмент не гарантирует удаление всех проприетарных метаданных. Для
чувствительного файла правило короткое: работать с копией, проверить результат
и только потом отправлять.
